/**
 * Stable, language-agnostic test hooks for Playwright E2E specs.
 * Kept in one place so source and specs can't drift. Values must never change
 * without updating the e2e specs that key off them.
 */
export const TEST_IDS = {
  // Login (multi-step: email → password)
  loginEmailInput: "login-email-input",
  loginContinueBtn: "login-continue-btn",
  loginPasswordInput: "login-password-input",
  loginSignInBtn: "login-signin-btn",

  // Header language switcher
  languageSwitcherTrigger: "language-switcher-trigger",
  languageOption: (code: string) => `language-option-${code}`,

  // Operator edit form — locked currency
  operatorDefaultCurrencyLocked: "operator-default-currency-locked",

  // RequireCurrency blocked state
  requireCurrencyAlert: "require-currency-alert",
} as const;
